// removed by extract-text-webpack-plugin
module.exports = {"label":"LanguageSelector-module__label___2n7un","icon":"LanguageSelector-module__icon___1dq-q","list":"LanguageSelector-module__list___2iUDz","item":"LanguageSelector-module__item___2iRBz"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/LanguageSelector/LanguageSelector.module.scss
// module id = 189
// module chunks = 0 1